export default __webpack_public_path__ + "static/media/r1_c1.65b26187.jpg";